"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBreakpointResizeListener = undefined;

var _constants = require("../../../packages/common-utilities/src/constants.js");

var _constants2 = _interopRequireDefault(_constants);

var _recompose = require("recompose");

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withBreakpointResizeListener = exports.withBreakpointResizeListener = (0, _recompose.lifecycle)({
  state: { breakpoint: 4 },
  componentDidMount: function componentDidMount() {
    var _this = this;

    window.addEventListener('resize', function () {
      var clientWidth = window.document.documentElement.clientWidth;

      if ((0, _ramda.isNil)(clientWidth) || clientWidth === 0) {
        clientWidth = window.innerWidth;
      }

      _this.setState({ breakpoint: _constants2.default.getBreakpointForWidth(clientWidth) });
    });

    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      var resizeEvent = document.createEvent("UIEvents");
      resizeEvent.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    } else {
      window.dispatchEvent(new Event("resize"));
    }
  }
});